import { getAllOrdersApiRequest, getMyOrdersApiCall } from '@guryou/api-client-gql';
import { execute } from './actionWrapper';
import { PURCHASES_GET_MANY, USER_ALL_ORDERS } from '../types';
const getAllPurchases = function () {
  let silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return async dispatch => execute(dispatch, () => getAllOrdersApiRequest(), PURCHASES_GET_MANY, null, null, silent);
};
const getMyOrders = () => async dispatch => execute(dispatch, () => getMyOrdersApiCall({
  sessions: ['id', 'resourceName', 'startTime', 'endTime']
}), USER_ALL_ORDERS);
export { getAllPurchases, getMyOrders };